import { createStore } from 'zustand/vanilla';
/** Connection status, who is in which call, who is online, and the socket to send on. */
export function createLive() {
    const store = createStore()((set) => ({
        status: 'offline',
        voice: {},
        presence: {},
        selectedChannelId: null,
        select: (selectedChannelId) => set({ selectedChannelId }),
    }));
    let socket = null;
    function setRealtime(realtime) {
        socket = realtime;
    }
    function sendRealtime(message) {
        socket?.send(message);
    }
    /** Applies one server event; channel events refetch the channel list. */
    function applyEvent(event, queries, onChannelRemoved) {
        switch (event.type) {
            case 'ready':
                store.setState({
                    voice: Object.fromEntries(event.voice.map((room) => [room.channelId, room.participants])),
                    presence: event.presence,
                });
                void queries.invalidateQueries({ queryKey: ['channels'] });
                return;
            case 'voice.state':
                store.setState((state) => {
                    const voice = { ...state.voice };
                    if (event.room.participants.length > 0)
                        voice[event.room.channelId] = event.room.participants;
                    else
                        delete voice[event.room.channelId];
                    return { voice };
                });
                return;
            case 'presence.updated':
                store.setState((state) => {
                    const presence = { ...state.presence };
                    if (event.status === 'offline')
                        delete presence[event.userId];
                    else
                        presence[event.userId] = event.status;
                    return { presence };
                });
                return;
            case 'channel.changed':
                void queries.invalidateQueries({ queryKey: ['channels'] });
                void queries.invalidateQueries({ queryKey: ['members', event.channelId] });
                void queries.invalidateQueries({ queryKey: ['roles', event.channelId] });
                return;
            case 'channel.removed':
                void queries.invalidateQueries({ queryKey: ['channels'] });
                onChannelRemoved(event.channelId);
                return;
            default:
                // pong, and message events (handled by the chat store)
                return;
        }
    }
    return { store, setRealtime, sendRealtime, applyEvent };
}
//# sourceMappingURL=live.js.map